export default "__VITE_ASSET__C69vdML3__"